import React from "react";

// reactstrap components
import {
  Container,
  Row,
  Col,
  Carousel,
  CarouselItem,
  CarouselIndicators,
} from "reactstrap";

// core components

const items = [
  {
    src: require("assets/img/products/water_col.jpg").default,
    altText: "Bistrica",
    caption: "Bistrica",
  },
  {
    src: require("assets/img/products/milk_col.jpg").default,
    altText: "Vrbaski jogurt 3.2%",
    caption: "Vrbaski jogurt 3.2%",
  },
  {
    src: require("assets/img/products/betternull33.jpg").default,
    altText: "Bistrica 0.33l",
    caption: "Bistrica 0.33l",
  },
  {
    src: require("assets/img/products/better_gazirana_05.jpg").default,
    altText: "Bistrica gazirana 0.5l",
    caption: "Bistrica gazirana 0.5l",
  },
  {
    src: require("assets/img/products/prirodna_better.jpg").default,
    altText: "Bistrica prirodna 0.33l",
    caption: "Bistrica prirodna 0.33l",
  },
  {
    src: require("assets/img/products/gauda_krug-1.jpg").default,
    altText: "Vranička gauda krug",
    caption: "Vranička gauda krug",
  },
  {
    src: require("assets/img/products/gauda_vakum.jpg").default,
    altText: "Vranička gauda vakum kriška",
    caption: "Vranička gauda vakum kriška",
  },
  {
    src: require("assets/img/products/jogurt_2.jpg").default,
    altText: "Vrbaski jogurt 2% mm",
    caption: "Vrbaski jogurt 2% mm",
  },
  {
    src: require("assets/img/products/kravlji_sir_vakum.jpg").default,
    altText: "Vranički masni kravlji sir kriška",
    caption: "Vranički masni kravlji sir kriška",
  },
  {
    src: require("assets/img/products/mlacanica-2.jpg").default,
    altText: "Vrbaska mlačanica",
    caption: "Vrbaska mlačanica",
  },
  {
    src: require("assets/img/products/pavlaka_12_0-18l.jpg").default,
    altText: "Vrbaska pavlaka 12% mm 180g",
    caption: "Vrbaska pavlaka 12% mm 180g",
  },
  {
    src: require("assets/img/products/pavlaka_12_0-41l.jpg").default,
    altText: "Vrbaska pavlaka 12% mm 410g",
    caption: "Vrbaska pavlaka 12% mm 410g",
  },
  {
    src: require("assets/img/products/pavlaka_20_0-18l.jpg").default,
    altText: "Vrbaska pavlaka 20% mm 180g",
    caption: "Vrbaska pavlaka 20% mm 180g",
  },
  {
    src: require("assets/img/products/pavlaka_20_0-41l.jpg").default,
    altText: "Vrbaska pavlaka 20% mm 410g",
    caption: "Vrbaska pavlaka 20% mm 410g",
  },
  {
    src: require("assets/img/products/zbir-2.jpg").default,
    altText: "Mliječni proizvodi",
    caption: "Mliječni proizvodi",
  },
  
  
];

function CarouselSection() {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [animating, setAnimating] = React.useState(false);
  const onExiting = () => {
    setAnimating(true);
  };
  const onExited = () => {
    setAnimating(false);
  };
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };
  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };
  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  return (
    <>
      <div className="section" id="carousel">
        <Container>
          <div className="title">
            <h4>Galerija proizvoda</h4>
          </div>
          <Row className="justify-content-center">
            <Col lg="8" md="12">
              <Carousel
                activeIndex={activeIndex}
                next={next}
                previous={previous}
              >
                <CarouselIndicators
                  items={items}
                  activeIndex={activeIndex}
                  onClickHandler={goToIndex}
                />
                {items.map((item) => {
                  return (
                    <CarouselItem
                      onExiting={onExiting}
                      onExited={onExited}
                      key={item.src}
                    >
                      <img src={item.src} alt={item.altText} />
                      <div className="carousel-caption d-none d-md-block">
                        <h5 className="text-black carusel-caption-background card">{item.caption}</h5>
                      </div>
                    </CarouselItem>
                  );
                })}
                <a
                  className="carousel-control-prev"
                  data-slide="prev"
                  href="#pablo"
                  onClick={(e) => {
                    e.preventDefault();
                    previous();
                  }}
                  role="button"
                >
                  <i className="now-ui-icons arrows-1_minimal-left"></i>
                </a>
                <a
                  className="carousel-control-next"
                  data-slide="next"
                  href="#pablo"
                  onClick={(e) => {
                    e.preventDefault();
                    next();
                  }}
                  role="button"
                >
                  <i className="now-ui-icons arrows-1_minimal-right"></i>
                </a>
              </Carousel>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default CarouselSection;
